import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notifications: [],
    newMessagesCount: null,
    loading: false,
    error: false,
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        getNotificationRequest: (state) => {
            state.loading = true;
            state.error = false;
        },
        getNotificationSuccess: (state, action) => {
            state.loading = false;
            state.notifications = action.payload;
            state.newMessagesCount = state.notifications.filter(notification => notification.status === "NEW").length;
            state.error = false;
        },
        getNotificationFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        resetNotification: () => initialState,
    },
});

export const { getNotificationRequest, getNotificationSuccess, getNotificationFailure, resetNotification  } = notificationSlice.actions;

export default notificationSlice.reducer;